/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2025-07-09 18:07:10
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2025-07-11 18:57:20
 * @FilePath: \gov-construction-industry-association-web\src\api\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import api from '@/utils/api';

// 字典列表 专家组别-EXPERT_GROUP；会员职务：MAJOR；奖项：AWARD
export function dicList(type, data) {
  return api.get(`/api/dict/list/${type}`, data);
}

// 菜单列表
export function getTreeList(params) {
  return api.get('/api/menu/treeList', params);
}

//轮播图
export function bannere(params) {
  return api.get('/api/banner/list', params);
}

// 公告列表 新闻资讯 协会党建
export function getAnnouncementPage(data) {
  return api.post('/api/announcement/page', data);
}

// 公告详情
export function getDetail(id, data) {
  return api.get(`/api/announcement/${id}`, data);
}
// 会员列表
export function getMemberPage(data) {
  return api.post('/api/member/page', data);
}
// 会员详情
export function getMemberDetail(id,data) {
  return api.get(`/api/member/${id}`, data);
}

// 专家库列表
export function getExpertPage(data) {
  return api.post('/api/expert/page', data);
}

// 专家详情
export function getExpertDetail(id, data) {
  return api.get(`/api/expert/${id}`, data);
}

// 评优评奖列表
export function getAwardPage(data) {
  return api.post('/api/award-evaluation/page', data);
}

// 资料下载列表
export function getMaterialPage(data) {
  return api.post('/api/material/page', data);
}

// 示例3：更新用户信息
export function updateUser(id, data) {
  return api.put(`/users/${id}`, data);
}

// 示例4：删除用户
export function deleteUser(id) {
  return api.delete(`/users/${id}`);
}

// 示例5：上传文件
export function uploadFile(file) {
  const formData = new FormData();
  formData.append('file', file);
  return api.upload('/upload', formData);
}


